export default __webpack_public_path__ + "static/media/steph.ac9c9a97.jpg";